export default function WelcomePage() {
    return (
        <main className="w-full h-screen flex gap-4 p-4">
            Welcome Page
        </main>
    )
}